angular.module('rightPaneModule')
  .controller('SchoolCustomersUsageController', ['$scope', 'teacherApi', '$state', 'tableColumns', 'tableSort', 'timeframe', 'cancelableResourceManager', '$filter', 'navigation',
    function($scope, $teacherApi, $state, $tableColumns, $tableSort, $timeframe, $cancelableResourceManager, $filter, $navigation) {

    $scope.listTableColumns = $tableColumns.getColumns('teacherCustomerUsage');
    $scope.activeMetric = $state.params.sort || $scope.listTableColumns[0];

    $scope.years = { list: null, selected: {} };
    $scope.hasCustomerUsageError = false;

    $scope.timeframes = {
      list: [
        { id: '7d', name: 'Last 7 Days', by: 'day', active: true },
        { id: '30d', name: 'Last 30 Days', by: 'week', active: false }
      ],
      selected: {}
    };

    var updateUsage = function() {
      $scope.schoolCustomersUsageReportingUrl = $teacherApi.getSchoolCustomersUsageExportUrl();

      // clear any previous data/dates from display and show spinner while fetching new data
      $scope.listTableData = undefined;

      //clear any previous errors off the scope
      $scope.hasCustomerUsageError = false;

      $teacherApi.getSchoolCustomersUsage().then(
        function(data) {
          if (!data.list || data.list.length < 1) {
            $scope.hasCustomerUsageError = true;
            return;
          }

          $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data.list);

          //set totals array, the first element is the empty status column so no display
          $scope.usageTotals = ['', 'All Educators', '', $filter('number')(data.totals.session_count), $filter('number')(data.totals.usage_time_in_min, 1), $filter('number')(data.totals.ave_usage_time_per_session, 1)];
        },
        function() {
          $scope.hasCustomerUsageError = true;
      });
    };

    var updateTableSort = function() {
      if ($scope.listTableData) {
        $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
      }
    };

    var updateData = function() {
      updateUsage();
    };

    var initializeData = function(e, item) {
      $scope.item = item;

      $scope.$on('updateSortableTable', updateTableSort);

      $scope.$on('listTableRowClicked', function(e, item) {
        $navigation.handleRoute(e, item, {teacherId: item.id});
      });
    };

    $scope.$on('updateYears', function(e, years) {
      $scope.years.list = angular.copy(years);
    });

    $scope.$on('yearSelected', updateData);

    $scope.$on('timeframeSelected', updateData);

    $scope.$on('itemReady', initializeData);
        updateUsage();
  }]);
